import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { Language } from 'interfaces/api/languages.interfaces'
import { axios } from 'modules/axios'

const getLanguages = async (): GetArrayResponse<Language> => {
  const { data: response } = await axios.request<Language[]>({
    method: 'GET',
    url: endpoints.languages.getLanguages(),
  })
  return response
}

export const languagesApi = {
  getLanguages,
}
